import { sendGetRequest, sendPostRequest } from '@/services/api.service'
import { API_USER, API_AUTH, GTR_CORE } from '@/config/api.config'

export const getAuthApi = () => {
  return sendGetRequest(`${GTR_CORE.BASE_API_URL}${GTR_CORE.AUTH}`)
}

export const postUpdateSettingsApi = user => {
  return sendPostRequest(`${API_USER.BASE_API_URL}${API_USER.UPDATE_SETTINGS}`, user)
}

export const postUpdatePasswordApi = password => {
  return sendPostRequest(`${API_USER.BASE_API_URL}${API_USER.UPDATE_PASSWORD}`, { password })
}

export const postSessionRefreshApi = () => {
  return sendPostRequest(
    `${API_AUTH.SESSION_REFRESH}`,
    {},
    {
      headers: {
        rid: 'session',
      },
    }
  )
}
